import { render } from "./InquiryWrite.vue?vue&type=template&id=5761d7c4"
import script from "./InquiryWrite.vue?vue&type=script&lang=js"
export * from "./InquiryWrite.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__